import { useLocation, Link } from 'react-router-dom'
import { useEffect } from 'react'
import { Button } from '@/components/ui/button'
import { useTranslation } from '@/hooks/useTranslation'
import { Helmet } from 'react-helmet-async'

const NotFound = () => {
	const { t } = useTranslation()
	const location = useLocation()

	useEffect(() => {
		console.error(
			'[404 Error] User attempted to access non-existent route:',
			location.pathname
		)
		console.error('[404 Error] Full location details:', {
			pathname: location.pathname,
			search: location.search,
			hash: location.hash,
			state: location.state,
			referrer: document.referrer,
			timestamp: new Date().toISOString(),
		})

		// Log if this might be an auth callback
		if (location.pathname.includes('auth/callback')) {
			console.error('[404 Error] This appears to be an auth callback URL!')
			console.error(
				'[404 Error] Check that auth callback routes are properly configured'
			)
		}
	}, [location])

	return (
		<div className="min-h-screen flex items-center justify-center bg-gray-100">
			<Helmet>
				<meta name="robots" content="noindex,follow" />
			</Helmet>
			<div className="text-center">
				<h1 className="text-4xl font-bold mb-4">404</h1>
				<p className="text-xl text-gray-600 mb-4">{t('notFound.oopsPageNotFound')}</p>
				<p className="text-sm text-gray-500 mb-6">
					{t('notFound.pageDoesNotExist', { pathname: location.pathname })}
				</p>
				<Button asChild>
					<Link to="/">{t('notFound.returnToHome')}</Link>
				</Button>
			</div>
		</div>
	)
}

export default NotFound
